import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { Surprise, TitleWithATextUnder } from "../../../../Constant";
import { TITLE_SWEETALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const TitleWithTextUnder = () => {
  const displayAlert = () => {
    SweetAlert.fire({ title: "It's Magic!", text: "Thank you for visiting Boho theme" ,confirmButtonColor:"#33BFBF"});
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={TitleWithATextUnder} span={TITLE_SWEETALERT} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="sweet-1" type="button" onClick={displayAlert}>
            {Surprise}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TitleWithTextUnder;
